import { SupplierState } from '@interfaces';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const supplierStateSelector = createFeatureSelector<SupplierState>('supplier');

export const getSupplierLocationId = (state: SupplierState): string => state.supplierLocationId;

export const selectSupplierLocationId = createSelector(supplierStateSelector, getSupplierLocationId);
